import { render } from "./PlotPayments.vue?vue&type=template&id=4565d552&scoped=true"
import script from "./PlotPayments.vue?vue&type=script&lang=js"
export * from "./PlotPayments.vue?vue&type=script&lang=js"

import "./PlotPayments.vue?vue&type=style&index=0&id=4565d552&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4565d552"]])

export default __exports__